import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toastSuccess } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getBrands } from '@store/design/action';
import { getAllBrands } from '@store/reducers';

import { setSystemUserPreferences } from '@services/commonService';
import { createFavouriteFolder, updateFavouriteFolder } from '@services/favouriteService';

import { getUserPreference, printApiError } from '@utils/Util';

const useCreateFolder = (initialFolderState) => {
	const [selectedValue, setSelectedValue] = useState(initialFolderState);
	const [brands, setBrandList] = useState([]);
	const [errors, setErrors] = useState(null);
	const brandsList = useSelector(getAllBrands) || [];
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getBrands(`?page=0&size=1000`));
	}, [dispatch]);

	useEffect(() => {
		const brandsArray = brandsList.map((brand) => ({
			...brand,
			value: brand?.name
		}));
		setBrandList(brandsArray);
	}, [brandsList]);

	const validateSelectedValue = () => {
		let newErrors = {};
		let isValid = true;

		if (!selectedValue.folderName) {
			newErrors.folderName = 'Folder name is required';
			isValid = false;
		}

		if (!selectedValue.brand?.id) {
			newErrors.brand = 'Brand is required';
			isValid = false;
		}

		setErrors(newErrors);
		return isValid;
	};

	const handleUserPreferenceUpdate = async (selected) => {
		const userPreference = getUserPreference();
		const body = {
			...userPreference,
			DEFAULT_FAVOURITE_FOLDER: selected
		};
		await setSystemUserPreferences(body);
	};

	const handleSubmit = async (onSuccess, isEdit, isUpdateUserPreference = true) => {
		try {
			dispatch(openLoader());
			if (!validateSelectedValue()) return;

			const queryParam = `?name=${encodeURIComponent(selectedValue?.folderName)}&brandId=${selectedValue?.brand?.id}&description=${selectedValue?.description || ''}`;
			const editQueryParam = `${selectedValue?.folderId}?name=${encodeURIComponent(selectedValue?.folderName)}&brandId=${selectedValue?.brand?.id}&description=${selectedValue?.description || ''}`;
			let response = {};

			if (isEdit) {
				response = await updateFavouriteFolder(editQueryParam);
			} else {
				response = await createFavouriteFolder(queryParam);
			}

			if (response) {
				if (isUpdateUserPreference) {
					handleUserPreferenceUpdate(
						isEdit ? { ...selectedValue, id: selectedValue?.folderId } : response
					);
				}
				if (onSuccess) onSuccess(response);
				toastSuccess('Folder created successfully');
			}
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	return {
		selectedValue,
		setSelectedValue,
		brands,
		errors,
		validateSelectedValue,
		handleSubmit
	};
};

export default useCreateFolder;
